import { createReducer, on } from '@ngrx/store';
import { EAuthInfo } from '../models/EAuthInfo';
import { EAuthActions } from '../actions';
import {
  ReviewPageActions,
  TransactionFormActions,
} from '../../create-request/actions';
import {
  StandingAuthReviewPageActions,
  StandingAuthFormActions
} from '../../standing-authorizations/actions';
import { EAuthorizationActions } from '../../setup-eAuthorization/actions';
import { InitReleaseActions } from '../../initiate-and-release/actions';

export const eAuthInfoKey = 'eAuthInfo';

export type State = EAuthInfo;

export const initialEAuthInfo: EAuthInfo = {
  selectedAccountHolder: [],
  isAccountHolderSelected: false,
  isOptedOut: true,
  eAuthError: false,
  generateLoaPdf: false,
  userInputRequired: false,
  eAuthEmailAddressError: false
};

export const eAuthInfoReducer = createReducer(
  initialEAuthInfo,
  on(EAuthActions.optIn, (state) => {
    let isAccountHolderSelected: boolean =
      state.selectedAccountHolder.length > 0;
    return {
      ...state,
      isOptedOut: false,
      isAccountHolderSelected: isAccountHolderSelected,
    };
  }),
  on(EAuthActions.optOut, (state) => {
    return {
      ...state,
      isOptedOut: true,
      isAccountHolderSelected: false,
      eAuthError: false,
    };
  }),
  on(EAuthActions.accountHolderSelected, (state, { type, ...update }) => {
    const { accountHolder } = update;
    return {
      ...state,
      selectedAccountHolder: accountHolder,
      isAccountHolderSelected: accountHolder.length > 0,
      eAuthError: false,
      isOptedOut: accountHolder.length > 0 ? false : true
    };
  }),
  on(EAuthActions.invalidSubmitClick, (state) => {
    return {
      ...state,
      eAuthError: true,
    };
  }),
  on(EAuthActions.missingEmailAddressSubmitClick, (state) => {
    return {
      ...state,
      eAuthEmailAddressError: true
    }
  }),
  on(InitReleaseActions.initReleaseByDraftIdSuccessful, (state, {response}) =>
  {
    const alleAuthAccountHolders = response.draftObject.alleAuthAccountHolders ?? response.draftObject.AlleAuthAccountHolders ?? [];
    let customerList = response.draftObject.isCreateSloa ? response.draftObject.customerListSloa ?? [] :response.draftObject.customerList ?? response.draftObject.eAuthAccountHolders ?? alleAuthAccountHolders;
    return {
      ...state,
      isOptedOut: !(response.draftObject.eauthSelected || response.draftObject.eAuthElectronicAuth || response.draftObject.eauthElectronicAuth),
      isAccountHolderSelected: !!(response.draftObject.eauthSelected || response.draftObject.eAuthElectronicAuth || response.draftObject.eauthElectronicAuth),
      selectedAccountHolder: customerList?.length > 0 ? customerList.map(customer => customer.customerId ?? customer.custID) : []
    }
  }),
  on(EAuthActions.generateLoaPdf, (state) => {
    return {
      ...state,
      generateLoaPdf: true,
    };
  }),
  on(EAuthActions.eAuthTableDisplay, (state, {userInputRequired}) => {
    return {
      ...state,
      userInputRequired: userInputRequired
    }
  }),
  on(EAuthorizationActions.submitEmailSuccess, (state) => {
    return {
        ...state,
        eAuthEmailAddressError: false
    }
  }),
  on(ReviewPageActions.submitAndCreateToggled, (state, payload) => {
    return {
        ...state,
        eAuthEmailAddressError: payload.isSubmitAndCreate ? state.eAuthEmailAddressError : false
    }
  }),
  on(
    TransactionFormActions.transactionTypeChanged,
    ReviewPageActions.editClicked,
    StandingAuthReviewPageActions.editClicked,
    TransactionFormActions.cancelClicked,
    StandingAuthFormActions.transactionTypeChanged,
    StandingAuthFormActions.cancelClicked,
    (state) => {
      return initialEAuthInfo;
    }
  )
);
